<script>
// 加载中
import InnerLoading from "@/components/spinner/spinner.vue";
// 动态表单模版
import Temp from '@/components/technician/temp/index'
import {
  processTaskHistorical, processUploadFiles,
  processUserRelevanceCompleteList
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
import {ClientId} from "@/lib/cli";
import {ImagePreview} from "vant";
export default {
  name: 'channelHistory',
  data() {
    return {
      roleName:'',
      innerLoading: false,
      // 动态表单模版
      returnObj: {},
      formDefine: {},
      flowNameObj:{},
      formFields: [],
      flagTemp: false,
      activeTab: '西藏-网点维护',
      // 列表数据
      page1: 1,//当前页
      size1: 20,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      inList: [],
      // 流程历史信息
      historyList: [],

      uploadFlag:false,
      uploadList:[],
      uploadObjList:{},
      //------
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      flagButton:false,
    }
  },
  components: {
    InnerLoading,
    Temp,
  },
  watch: {
    // 监控参数变化更新游戏列表接口数据
    searchParams: function (newVal,oldVal) {
      if(newVal.category!==oldVal.category){
        this.page1 = 1;
      }
      this.getListData();
    },
  },
  computed: {
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize: this.size1,//每页数量
        pageNum: this.page1,//当前页码
        category: '',//this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
  },
  created() {
    if(getLocalItem('roles')){
      this.roleName = getLocalItem('roles');
    }
    // 当前任务列表数据
    this.getListData();
  },
  methods: {
    // getLoad(item){
    //   this.uploadObjList = item;
    //   if(item.uploadFiles){
    //     this.uploadFlag = true;
    //     item.uploadFiles.map((v,k)=>{
    //       if(v.state){
    //         if(v.value){
    //           v.files = [{
    //             url:v.value
    //           }];
    //         }
    //       }else{
    //         v.files = [];
    //       }
    //     });
    //     this.uploadList = item.uploadFiles;
    //     const emptyField = this.uploadObjList.uploadFiles.find(item => !item.value);
    //     this.flagButton = emptyField!==undefined;
    //   }
    // },
    getClose() {
      if(this.uploadObjList.uploadFiles&&this.uploadObjList.uploadFiles.length>0){
        const emptyField = this.uploadObjList.uploadFiles.find(item => !item.value);
        if(emptyField){
          this.$toast(`请完善资料上传！`);
          return false;
        }
        this.uploadFlag = false;
        this.getListData();
      }
    },
    // 图片放大
    showPreview(index, item) {
      let arr = [];
      item.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url)
        }else{
          arr.push(v.url)
        }
      });
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    // -------------
    beforeUploadImg1(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg1 = false;
      // this.imgForm2.showVideoPath = URL.createObjectURL(file);
    },
    handleSuccess(response, file, fileList, index) {
      console.log(response, file, fileList, index)
      this.loading = true;
      this.isShowUploadImg1 = true;
      this.imgFlag1 = false;
      this.imgUploadPercent1 = 0;
      //后台上传数据
      if (response.code === 200) {
        if(response.data){
          this.loading = false;
          let arr = [];
          fileList.map((v)=>{
            if(v.response){
              arr.push(v.response.data.url)
            }
          });
          this.uploadList[index].files = fileList;
          console.log(arr)
          console.log(arr.length)
          console.log(arr.length>1)
          console.log(arr.join(','))
          this.uploadList[index].value = arr.join(',');
          // this.getUploadImg()
        }
      } else {
        this.$toast(response.msg);
        return false;
      }
    },
    handleExceed(files, fileList) {
      console.log(files, fileList)
      this.$toast(`最多只能上传 1 张图片`);
    },
    handleRemove(file, fileList, index) {
      console.log(file, fileList, index)
      let arr = []
      fileList.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url);
        }
      });
      this.uploadList[index].files = fileList;
      this.uploadList[index].value = arr.join(',');
    },

    getUploadImg(item,index){
      if(!this.uploadList[index].value){
        this.$toast(`请上传 ${item.name} 资料`);
        return false;
      }
      let params = {
        processInstanceName:this.uploadObjList.processInstanceName,
        processInstanceId:this.uploadObjList.processInstanceId,
        name:item.name,
        value:this.uploadList[index].value
      }
      processUploadFiles(params).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(res.data.code===200){
            this.$toast('提交成功');
            this.uploadList[index].state = true;

          }else{
            this.$toast(res.msg);
            return false;
          }
        }
      });
    },
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    // 当前任务列表数据
    getListData() {
      this.loading1 = true;
      this.finished1 = false;
      if(this.searchParams.pageNum===1){
        this.inList = []
      }
      processUserRelevanceCompleteList(this.searchParams).then((res) => {
        if (res) {
          if (res.data) {
            this.loading1 = false;
            if (res.data.code === 200) {
              let resData = res.data.data.taskQueryOutputList
              this.totals1 = res.data.data.totalCount;
              this.totalPages1 = Math.ceil(res.data.data.totalCount / this.size1);
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                resData.map((v)=>{
                  if(v.processInstanceName){
                    if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>1){
                      v.arr_name = v.processInstanceName.split('-')[1];
                    }else{
                      v.arr_name = v.processInstanceName;
                    }
                  }else if(v.processDefinitionName){
                    if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                      v.arr_name = v.processDefinitionName.split('-')[1];
                    }else{
                      v.arr_name = v.processDefinitionName;
                    }
                  }
                });
                if (this.page1 > 1) {
                  this.inList = this.inList.concat(resData);
                } else {
                  this.inList = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 查看网点
    getQuerySiteIdInfo(siteId) {
      if (siteId) {
        this.$router.push({path: '/techSiteId', query: {'siteId': siteId}});
      } else {
        this.$toast('无网点编号');
      }
    },
    // 任务详情
    getHistoryObjectData(processInstanceId) {
      processTaskHistorical({
        processInstanceId: processInstanceId,
        handler: false
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if (res.data.data.historicActivityInstances && res.data.data.historicActivityInstances.length > 0) {
                res.data.data.historicActivityInstances.map((v) => {
                  if (v.formInfo.fields) {
                    v.formInfo.fields.map((i) => {
                      if (i.params.customDesign.type === 'fileupload') {
                        i.files = i.value ? i.value.split(',') : [];
                      } else if (i.params.customDesign.type === 'rate') {
                        i.value = parseInt(i.value) / 2;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
                this.flagTemp = true;
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },

    // 流程表单提交接口
    getTempReturn(data) {
      console.log(data)
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      this.getListData();
    },
  }
}
</script>
<template>
  <div class="tech-content">
    <!--    加载中-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    动态表单模版-->
    <Temp v-model="flagTemp" content="close" :variablesObj="{}" :historyList="historyList" :flowNameObj="flowNameObj" :siteIdObj="{}"
          :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>

    <!--    上传图片弹窗-->
    <van-popup
        v-model="uploadFlag"
        round
        :close-on-click-overlay="false"
        position="bottom"
    >
      <div class="" >
        <div class="form-section">
          <div class="supply-item">
            <div class="supply-header">
              <div class="supply-name">{{uploadObjList.arr_name}}</div>
              <div class="supply-btn" @click="uploadFlag=false"><van-icon name="cross" /></div>
            </div>
            <div class="quantity-section">
              <div class="warehouse-label"><span></span>资料上传</div>
              <div class="warehouse-section" v-for="(v,k) in uploadList" :key="k">
                <div class="warehouse-clo">
                  <div class="warehouse-label-tit">{{ v.name }}</div>
                  <div class="group-video">
                    <div class="group-video-load" >
                      <el-upload
                          v-if="!v.state"
                          class="avatar-uploader"
                          :action="fileVideoUrl"
                          :headers="headers"
                          :limit="1"
                          multiple
                          :file-list="v.files"
                          accept="image/jpeg, image/jpg, image/png"
                          list-type="picture-card"
                          :on-exceed="handleExceed"
                          :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, k)"
                          :before-upload="beforeUploadImg1"
                          :on-remove="(file, fileList) => handleRemove(file, fileList, k)">
                        <i class="el-icon-plus"></i>
                      </el-upload>

                      <van-image
                          v-else
                          v-for="(val,kes) in v.files" :key="kes"
                          :src="val.url"
                          @click="showPreview(kes,v.files)"
                      /></div>
                  </div>
                  <div class="sub-btn" v-if="!v.state"><div class="clo-btn" @click="getUploadImg(v,k)">提交</div></div>
                </div>
              </div>
              <div class="form-buttons-btm" v-if="flagButton">
                <van-button block plain type="primary" @click="getClose">确定</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div>
      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                @load="onLoad">
        <div class="card" v-for="(item,index) in inList" :key="index">
          <div class="card-title">
            {{ item.arr_name }}
          </div>
          <div class="card-info">
            <div class="card-info-item">流程进度：{{ item.name }}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item">网点编号：{{ item.variables.siteid }}</div>
            <div class="card-info-item">地区：{{ item.variables.city }}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item" v-if="item.variables&&item.variables.name">联系人：{{ item.variables.name }}
            </div>
            <div class="card-info-item" v-if="item.variables&&item.variables.phone">
              联系电话：{{ item.variables.phone }}
            </div>
          </div>
          <div class="card-footer">
            <div>完成时间：{{ item.endTime }}</div>
            <div>
              <button class="btns btn-secondary" v-show="item.siteid" @click="getQuerySiteIdInfo(item.siteid)">
                查看网点
              </button>
              <button class="btns btn-secondary" @click="getHistoryObjectData(item.processInstanceId)">任务详情</button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tech-content {
  padding-top: 120px;
  box-sizing: border-box;
}
</style>